module.exports = __webpack_public_path__ + "static/media/objectives.1bd06b17.png";